<!--d-xl-none d-block-->
<div class="shipping-items-card">
  @if(orderLines?.length > 0){
  <app-delivery-items-card-header></app-delivery-items-card-header>
  }
  <div class="shipping-items-list mb-32-px">
    @if(orderLines?.length > 0){
    @for (orderLine of orderLines; track orderLine.id) {
    <app-delivery-item-card [orderLine]="orderLine" [inOrder]="inOrder" [order]="order">
    </app-delivery-item-card>
    }
    } @else {
    <p class="empty-cart-text">Your cart is empty</p>
    }
  </div>
</div>
